import React from 'react';
import mainLogo from '../../../assets/images/game-bts/Logo-Bill-Roojai-bts.png';
import navLogo from '../../../assets/images/game-bts/nav-logo.webp';
import elem01 from '../../../assets/images/game-bts/element-bts_01.png';
import elem02 from '../../../assets/images/game-bts/element-bts_02.png';
import elem03 from '../../../assets/images/game-bts/element-bts_03.png';
import elem04 from '../../../assets/images/game-bts/element-bts_04.png';
import elem05 from '../../../assets/images/game-bts/element-bts_05.png';
import './HeaderHero.css';

const HeaderHero = () => {
  return (
    <div className="bts-hero">
      {/* BIG C Logo badge - tilted */}
      <div className="bts-hero__logo-wrap">
        <img src={navLogo} alt="Big C" className="bts-hero__logo" />
      </div>

      {/* Element decorations */}
      <img src={elem01} alt="" className="bts-hero__elem bts-hero__elem--1" />
      <img src={elem02} alt="" className="bts-hero__elem bts-hero__elem--2" />
      <img src={elem03} alt="" className="bts-hero__elem bts-hero__elem--3" />
      <img src={elem04} alt="" className="bts-hero__elem bts-hero__elem--4" />
      <img src={elem05} alt="" className="bts-hero__elem bts-hero__elem--5" />

      {/* Main Logo */}
      <div className="bts-hero__main-logo-wrap">
        <img src={mainLogo} alt="บิลรู้ใจคุณ เปิดเทอมใหญ่ หัวใจว้าวุ่น" className="bts-hero__main-logo" />
      </div>
    </div>
  );
};

export default HeaderHero;
